<template>
  <div class="component-content sub-content">
    <!-- <div class="list-title no-bottom-border">
      <div class="r">
        <el-button v-if="backRole('PM_1')" type="primary" @click="startCreate()" size="mini">项目申请</el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId" placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div> -->
    <div class="list-title">
      <span class="r">
        <el-tooltip style="margin-right:5px;" v-if="backRole('ST_12')" effect="dark" content="点击生成当月报表"
          placement="bottom">
          <el-button size="mini" @click="makeReport()" type="success">生成报表</el-button>
        </el-tooltip>

        <a :href="baseURL+'/storage/material/report/download?houseId='+houseId+'&time='+reportTime+'&accesstoken='+userData.accesstoken"
          style="float:right;position:relative;z-index:2;" target="_blank">
          <el-button size="mini" type="primary">材料月度报表下载</el-button>
        </a>
      </span>

      <el-row>
        <label class="label-name">当前仓库：</label>
        <el-select size="mini" style="width:120px;" class="organization-select" v-model="houseId" placeholder="请选择仓库">
          <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>

        <label class="label-name" style="margin-left:10px;">报表时间：</label>
        <el-date-picker size="mini" style="width:120px!important" v-model="reportTime" value-format="yyyy-MM"
          type="month" placeholder="选择年月" :picker-options="pickerOptions">
        </el-date-picker>

        <label style="margin-left:10px;">搜索：</label>
        <el-input style="width:200px" v-model="filterKey" size="mini" placeholder="材料明细名称/材料编号"></el-input>
      </el-row>
    </div>

    <div class="table-total" v-if="reportData">
      <ul class="total-ul">
        <li>
          <label>上月结余</label>
          <label class="sz">数量：{{ reportData.lastAmountTotal }}</label>
          <label class="sz">金额：{{ reportData.lastFeeTotal }}</label>
        </li>
        <li>
          <label>本月入库</label>
          <label class="sz">数量：{{ reportData.inAmountTotal }}</label>
          <label class="sz">金额：{{ reportData.inFeeTotal }}</label>
        </li>
        <li>
          <label>本月出库</label>
          <label class="sz">数量：{{ reportData.outAmountTotal }}</label>
          <label class="sz">金额：{{ reportData.outFeeTotal }}</label>
        </li>
        <li>
          <label>本月退库</label>
          <label class="sz">数量：{{ reportData.backAmountTotal }}</label>
          <label class="sz">金额：{{ reportData.backFeeTotal }}</label>
        </li>
        <li>
          <label>本月盘点</label>
          <label class="sz">数量：{{ reportData.panAmountTotal }}</label>
          <label class="sz">金额：{{ reportData.panFeeTotal }}</label>
        </li>
        <li>
          <label>本月结余</label>
          <label class="sz">数量：{{ reportData.curAmountTotal }}</label>
          <label class="sz">金额：{{ reportData.curFeeTotal }}</label>
        </li>
      </ul>
    </div>
    <el-table :data="paginationData" style="width: 100%" :height="tableHeight" v-loading="loading">
      <!--  -->
      <el-table-column prop="material.number" fixed label="材料编码" width="70px">
      </el-table-column>
      <el-table-column prop="material.name" fixed label="明细名称" width="150px">
      </el-table-column>
      <el-table-column prop="material.unit.name" fixed label="单位" width="40px" align="center">
      </el-table-column>
      <el-table-column label="上月结余" align="center">
        <el-table-column prop="lastAmount" label="数量" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="lastPrice" label="单价" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="lastFee" label="金额" width="80px" align="right">
        </el-table-column>
      </el-table-column>
      <el-table-column label="本月入库" align="center">
        <el-table-column prop="inAmount" label="数量" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="inPrice" label="单价" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="inFee" label="金额" width="80px" align="right">
        </el-table-column>
      </el-table-column>
      <el-table-column label="本月出库" align="center">
        <el-table-column prop="outAmount" label="数量" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="outPrice" label="单价" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="outFee" label="金额" width="80px" align="right">
        </el-table-column>
      </el-table-column>
      <el-table-column label="本月退货" align="center">
        <el-table-column prop="backAmount" label="数量" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="backPrice" label="单价" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="backFee" label="金额" width="80px" align="right">
        </el-table-column>
      </el-table-column>
      <el-table-column label="盘存损益" align="center">
        <el-table-column prop="panAmount" label="数量" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="panPrice" label="单价" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="panFee" label="金额" width="80px" align="right">
        </el-table-column>
      </el-table-column>
      <el-table-column label="本月结存" align="center">
        <el-table-column prop="curAmount" label="数量" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="curPrice" label="单价" width="60px" align="right">
        </el-table-column>
        <el-table-column prop="curFee" label="金额" width="80px" align="right">
        </el-table-column>
      </el-table-column>
    </el-table>

    <!-- 生成报表弹窗 -->
    <section class="pop-room report-pop" v-if="makeReportStatus">
      <a href="javascript:;" @click="makeReportStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="*仓库">
              <el-select size="mini" class="organization-select" v-model="form.houseId" placeholder="请选择仓库">
                <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="*报表月份">
              <el-date-picker size="mini" v-model="form.time" value-format="yyyy-MM" type="month" placeholder="选择年月"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button @click="submitMakeReport()" size="small" type="primary">确认生成</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </section>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  export default {
    components: {},
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        // 生成报表
        makeReportStatus: false,
        form: {
          houseId: '',
          lastTime: '',
          time: ''
        },

        pickerOptions: {
          disabledDate(time) {
            return false
            // return time.getTime() > Date.now() - 8.64e6
          }
        },
        baseURL: axios.defaults.baseURL,

        houseId: '',
        houseList: [],

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',
        reportTime: '',

        // 列表
        loading: true,
        pageSize: 5000,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        reportData: '',

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],

        tableHeight: 1000,

        allHouseList: [],
      }
    },
    created() {
      console.log(document.documentElement.clientHeight)
      this.tableHeight = document.documentElement.clientHeight - 180 - 100

      // this.getAllHouse()
    },
    mounted() {
      // this.organizationListData.push({
      //   id: 0,
      //   name: "集团所有公司",
      //   depId: 0
      // })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7") {
        this.noSelectOrganization = false
        // this.depId = 0
      }

      // 获取仓库列表
      this.getHouseList()
    },
    methods: {
      // 生成报表
      submitMakeReport() {
        let _time = this.form.time.split("-")
        let _year = _time[0],
          _m = util.getTwoChar((parseInt(_time[1]) - 1), 1)

        if(_m==0){
          _m = 12
          _year --
        }
        this.form.lastTime = _year + '-' + _m
        console.log(this.form.lastTime)

        this.loading = true
        this.makeReportStatus = false
        ajax.post('/storage/material/report/make', this.form, (res) => {
          this.getLists()
        })
      },
      // 点击生成报表弹窗
      makeReport() {
        this.form.houseId = this.houseId
        this.form.time = this.reportTime
        this.makeReportStatus = true
      },
      // 获取所有仓库
      getAllHouse(cb) {
        // 获取所有仓库
        ajax.get('/storage/house/list', {
          'depId': '' //this.form.depId
        }, (res) => {
          this.allHouseList = res.vo.array
          cb && cb()
        })
      },
      // 获取仓库列表
      getHouseList() {
        // 只能看到拥有权限的仓库
        this.houseList = this.managerStorage

        let _date = new Date()
        let _year = _date.getFullYear(),
          _m = util.getTwoChar(_date.getMonth(), 1)

        if(_m==0){
          _m = 12
          _year --
        }
        this.reportTime = _year + '-' + _m
        console.log(this.reportTime)

        if (this.backRole('ST_13')) {
          this.getAllHouse(() => {
            this.houseList = this.allHouseList

            if (this.houseList.length < 1) {
              this.$message.error('您暂无可以查看月报表权限的仓库，无法查看材料报表')
              this.loading = false
              return
            }
            // 获取库存
            this.getLists()
          })
        } else {
          if (this.houseList.length < 1) {
            this.$message.error('您暂无可以查看月报表权限的仓库，无法查看材料报表')
            this.loading = false
            return
          }
          // 获取库存
          this.getLists()
        }
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        // console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _m = this.listData[i]

            // if (_filterStatus) {
            if (_m.material.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 ||
              _m.material.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_m)
            }
            // }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        if (this.houseList.length < 1 || !this.reportTime) {
          return
        }
        if (!this.houseId && this.houseList.length > 0) {
          this.houseId = this.houseList[0].id
        }
        if (!this.houseId) {
          this.$message.error("您必须先选择一个仓库")
          return
        }

        this.loading = true
        ajax.get('/storage/material/report', {
          houseId: this.houseId,
          time: this.reportTime
        }, (res) => {
          this.loading = false
          this.reportData = res.vo
          if (!res.vo) {
            this.$message.error("该仓库暂未生成该月(" + this.reportTime + ")报表")
            this.filterData = this.listData = []
            this.getPaginationData()
          } else {
            this.filterData = this.listData = res.vo.items
            this.getPaginationData()
          }
        })
      },
    },
    watch: {
      'houseId'() {
        this.getLists()
      },
      'reportTime'() {
        this.getLists()
      },
      'filterKey'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/storage/reportList.vue